var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('th',{class:{ 'claw-th': _vm.name === 'claw' },domProps:{"innerHTML":_vm._s(_vm.th)}}),_vm._l((_vm.specification),function(item,index){return _c('td',{key:index},[_vm._v(" "+_vm._s(item[_vm.name])+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }